import { createContext, useContext, type RefObject } from "react";

interface BoardScrollContextValue {
  scrollRef: RefObject<HTMLDivElement | null>;
  wrapperRef: RefObject<HTMLDivElement | null>;
}

export const BoardScrollContext = createContext<BoardScrollContextValue | null>(
  null,
);

export function useBoardScroll(): BoardScrollContextValue {
  const ctx = useContext(BoardScrollContext);
  if (!ctx) {
    throw new Error("useBoardScroll must be used within a <Board>");
  }
  return ctx;
}
